import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {DropdownButton, MenuItem} from 'react-bootstrap';
import Icon from 'components/ui/element/Icon';


/** Component to render a dropdown */
class SpogDropdown extends Component {
    static propTypes = {
        id:        PropTypes.string.isRequired, // The id for the dropdown
        title:     PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // The text for the label
        icon:      PropTypes.string, // The icon for the dropdown
        value:     PropTypes.string, // The value of the dropdown
        onChange:  PropTypes.func, // Listener when the value changes
        items:     PropTypes.array.isRequired, // The items to show inside the dropdown
        disabled:  PropTypes.bool, // True if the dropdown is disabled
        clearable: PropTypes.bool // True if the dropdown could be cleared
    };

    static state = {
        disabled:  false,
        clearable: false
    };

    componentWillMount() {
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    }

    /** Return the full array of items to draw in the dropdown
     * @param {Array} buttons array with the options to select in the dropdown
     * */
    createItemsArray(buttons) {
        const {intl: {formatMessage}} = this.props;

        return []
            .concat(buttons)
            .concat(['-', {
                id:   'clear',
                text: formatMessage({id: 'dropdown.clear'})
            }]);
    }

    handleChangeDropdown(filterValue) {
        const {onChange} = this.props;
        const value = filterValue === 'clear' ? '' : filterValue;

        onChange && onChange(value);
    }

    renderItem(item, index) {
        const {value, disabled} = this.props;

        return item === '-' ?
            <MenuItem
                key={`dropdown-separator-${index}`}
                divider
            /> :
            <MenuItem
                key={`dropdown-item-${item.id}`}
                eventKey={item.id}
                disabled={disabled || item.disabled}
                active={item.id === value}
            >
                {item.text}
            </MenuItem>;
    }

    renderItems() {
        const {items, clearable} = this.props;

        let formattedItems = items;

        if (clearable) {
            formattedItems = this.createItemsArray(formattedItems);
        }

        return formattedItems.map(this.renderItem.bind(this));
    }

    renderTitle() {
        const {icon, title, value, items} = this.props;

        let _title = title;

        if (!_title) {
            const item = items.find(_item => _item.id === value);

            if (item) {
                _title = item.text;
            }
        }

        return (
            <span>
                {icon ? <Icon name={icon} /> : null}
                {_title}
            </span>
        );
    }

    render() {
        const {id, disabled} = this.props;

        return (
            <DropdownButton
                id={id}
                title={this.renderTitle()}
                onSelect={this.handleChangeDropdown}
                disabled={disabled}
            >
                {this.renderItems()}
            </DropdownButton>
        );
    }
}

export default injectIntl(SpogDropdown);



// WEBPACK FOOTER //
// ./src/components/ui/form/SpogDropdown.js